import React from 'react'
import { twMerge } from 'tailwind-merge'

import { ButtonProps } from './Button.types.ts'

const Button: React.FC<ButtonProps> = ({
  variant,
  size,
  color,
  children,
  onClick,
  icon,
  type,
  className = '',
  disabled = false,
  fullWidth = false
}) => {
  const baseClasses =
    'inline-flex items-center justify-center font-medium rounded focus:outline-none transition'

  const sizeClasses = {
    small: 'px-7 py-2 text-sm',
    medium: 'px-8 py-3 text-base',
    large: 'px-10 py-5 text-lg'
  }

  const colorClasses = {
    primary: {
      filled: 'bg-blue-500 text-white hover:bg-blue-600',
      outlined: 'border border-blue-500 text-blue-500 hover:bg-blue-100'
    },
    secondary: {
      filled:
        'bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700',
      outlined:
        'border border-gray-200 hover:bg-gray-100 dark:border-gray-700 dark:hover:bg-gray-800'
    },
    success: {
      filled: 'bg-green-500 text-white hover:bg-green-600',
      outlined: 'border border-green-500 text-green-500 hover:bg-green-100'
    },
    danger: {
      filled: 'bg-red-500 text-white hover:bg-red-600',
      outlined: 'border border-red-500 text-red-500 hover:bg-red-100'
    },
    warning: {
      filled: 'bg-yellow-500 text-white hover:bg-yellow-600',
      outlined: 'border border-yellow-500 text-yellow-500 hover:bg-yellow-100'
    }
  }

  const buttonClasses = twMerge(
    baseClasses,
    sizeClasses[size],
    colorClasses[color][variant],
    disabled && 'opacity-50 cursor-not-allowed',
    fullWidth && 'w-full',
    className
  )

  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      type={type || 'button'}
    >
      {icon && <span className="mr-2">{icon}</span>}
      {children}
    </button>
  )
}

export default Button
